import { Component, effect, inject, input, signal } from '@angular/core';
import { ConstitutionAttorniesStore } from '../../stores/constitution-attornies.store';
import { DropdownModule } from "primeng/dropdown";
import { CalendarModule } from 'primeng/calendar';
import { RESPONSIBILITY } from '../../models/representative';
import { ReactiveFormsModule } from '@angular/forms';
import { ClientsTableComponent } from '../../../../clients-table/clients-table.component';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputTextModule } from 'primeng/inputtext';
import { NgClass } from '@angular/common';


@Component({
  selector: 'app-constitution-representatives',
  standalone: true,
  imports: [DropdownModule, CalendarModule, ReactiveFormsModule, ClientsTableComponent, InputTextareaModule, InputTextModule, NgClass],
  templateUrl: './constitution-representatives.component.html',
  styleUrl: '../../constitution-form.component.scss',
})
export class ConstitutionRepresentativesComponent {

  store = inject(ConstitutionAttorniesStore);
  activeTab = input<string>('constitution');
  clientId = input<number | null>(null);
  deferPersistence = input(false);
  readonly responsibilityOptions = signal(RESPONSIBILITY);

  constructor() {
    effect(() => {
      this.store.setClientId(this.clientId());
    }, { allowSignalWrites: true });
  }

  saveAttorney(): void {
    this.store.saveAttorney(this.deferPersistence());
  }

  deleteAttorney(index: number): void {
    this.store.deleteAttorney(index, this.deferPersistence());
  }

  goToClientDetail(index: number): void {
    this.store.goToClientDetail(index, this.activeTab() || 'constitution');
  }

}
